/**
 * this file contains all redux-saga watchers & workers for the transaction
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Tom on 19/06/18
 */

import { takeEvery, call, put, select } from 'redux-saga/effects'
import moment from 'moment'

import C from '../constants'
import config from '../config'
import { request, isEmpty, substitute } from '../utility/utilities'

// import action creators
import * as TransactionActions from '../actions/transactionActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE LIST OF TRANSACTIONS
----------------------------------------------------------------------------- */

// watcher saga for fetching the transaction data
export function* watchFetchTransaction() {
    yield takeEvery(C.FETCH_TRANSACTION_DATA, workerFetchTransaction)
}

// worker saga for fetching the transaction data
function* workerFetchTransaction() {

    // get the store content
    const state = yield select();
    const startDate = (state.transactionState.startDate).format('YYYY-MM-DD');
    const endDate = (state.transactionState.endDate).format('YYYY-MM-DD');

    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors', // NOTE: make sure Mulesoft endpoint allows CORS !!!!!!
        cache: 'default'
    }

    // set the endpoint
    const requestURL = substitute(config.endpoints.transactionFetchURL, {startDate: startDate, endDate: endDate})

    try {

        // show the loader
        yield put(TransactionActions.showTransactionLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            // get the array of transaction objects
            const bankAccountDetails = response.data.data

            //console.log(JSON.stringify(bankAccountDetails, null, 4))

            // set the closing balance
            yield put(TransactionActions.setTransactionClosingBalance(
                parseFloat(bankAccountDetails.closing_balance, 10)
            ))

            // set the transaction list
            yield put(TransactionActions.setTransactionData(
                bankAccountDetails.transactions
            ))

            // set the success flag to true
            yield put(TransactionActions.setTransactionFetchSuccess(true))
        }

    } catch (error) {

        // set the success flag to false
        yield put(TransactionActions.setTransactionFetchSuccess(false))

    } finally {

        // hide the loader regardless
        yield put(TransactionActions.showTransactionLoader(false))
    }
}

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO RESET THE DATE RANGE
----------------------------------------------------------------------------- */

// watcher saga for resetting the date range
export function* watchClearDateRange() {
    yield takeEvery(C.CLEAR_DATE_RANGE, workerClearDateRange)
}

// worker saga for resetting the date range
function* workerClearDateRange() {

    // set the start date of 3 months from NOW
    yield put(TransactionActions.setTransactionStartDate(
        moment().subtract(3, 'months')
    ))

    // set the end date of NOW
    yield put(TransactionActions.setTransactionEndDate(
        moment()
    ))
}



// WEBPACK FOOTER //
// ./src/sagas/transactionSaga.js